import {fetchConToken} from '../helpers/fetch'
import {WorkingDocs} from '../types-module/WDocsNS'

const getAdminUsers = async () => {
  const resp = await fetchConToken('user/admin', {}, 'GET')

  const body = await resp.json()

  return body
}

const getResponsablesUsers = async () => {
  const resp = await fetchConToken('user/responsablesproceso', {}, 'GET')

  const body = await resp.json()

  return body
}

const getInvitadosUsers = async () => {
  const resp = await fetchConToken('user/invitadosproceso', {}, 'GET')

  const body = await resp.json()

  return body
}

const getAllUsersPag = async (currentPage: any, numberData: any, options: any) => {
  const queryString = new URLSearchParams(options).toString()

  const resp = await fetchConToken(`user/${currentPage}/${numberData}?${queryString}`, {}, 'GET')

  const body = await resp.json()

  return body
}

const getAllUsersColabsPag = async (currentPage: any, numberData: any, options: any) => {
  const queryString = new URLSearchParams(options).toString()

  const resp = await fetchConToken(
    `user/colabs/${currentPage}/${numberData}?${queryString}`,
    {},
    'GET'
  )

  const body = await resp.json()

  return body
}

const getAllUsersSinPag = async () => {
  const resp = await fetchConToken('user', {}, 'GET')

  const body = await resp.json()

  return body
}

const getAllUsersAsignacionSinPag = async () => {
  const resp = await fetchConToken('user/asignaciongrupo', {}, 'GET')

  const body = await resp.json()

  return body
}

const updateUserData = async (id: string, updatedData: any) => {
  const resp = await fetchConToken(`user/roles/${id}`, updatedData, 'PUT')
  const body = await resp.json()

  return body
}

const updateUserEnterpricesAndRols = async (
  id: string,
  updateData: {rol?: string[]; empresa: string[]; contraseña: string}
) => {
  const resp = await fetchConToken(`user/enterprices/rols/${id}`, updateData, 'PUT')

  return await resp.json()
}

const acceptTerminosCondicionesUser = async (id: string, updatedData: any) => {
  const resp = await fetchConToken(`user/accept/terminosycondiciones/${id}`, updatedData, 'PUT')
  const body = await resp.json()

  return body
}

const getRoles = async (): Promise<{
  success: boolean
  data?: WorkingDocs.Role[]
  error?: string
}> => {
  const resp = await fetchConToken('user/getroles/', {}, 'GET')
  const body = await resp.json()

  return body
}

const getTerminosUserId = async (id: string) => {
  const resp = await fetchConToken(`user/getterminos/${id}`, {}, 'GET')
  const body = await resp.json()

  return body
}

const deleteUser = async (id: string) => {
  const resp = await fetchConToken(`user/${id}`, {}, 'DELETE')

  const body = await resp.json()
  return body
}

const activarUser = async (id: string) => {
  const resp = await fetchConToken(`user/activar/${id}`, {}, 'PUT')

  const body = await resp.json()
  return body
}
const updateUser = async (
  id: string,
  updateData: {unidades: {empresaId: string; codUnidad: string; DesUnid: string}[]}
) => {
  const resp = await fetchConToken(`user/updateuser/${id}`, updateData, 'PUT')

  return await resp.json()
}

const getRolsByCompany = async () => {
  const resp = await fetchConToken('user/rols_by_enterprice', {}, 'GET')
  return await resp.json()
}

const createUser = async (data: {
  nombres: string
  apellido_paterno: string
  apellido_materno: string
  email: string
  empresa: string[]
  dni: string
  roles: {rol: string[]; empresa: string}[]
}) => {
  const resp = await fetchConToken('user/create', data, 'POST')
  const body = await resp.json()

  return body
}

const getUserById = async (id: string) => {
  const resp = await fetchConToken(`user/list/get/${id}`, {}, 'POST')
  const body = await resp.json()

  return body
}

const getUserByIdDashboard = async () => {
  const resp = await fetchConToken('user/list/dashboard/get', {}, 'POST')
  const body = await resp.json()

  return body
}

const getAllUsersByCompanyPagination = async (companyId: string, options: any) => {
  const queryString = new URLSearchParams(options).toString()

  const resp = await fetchConToken(`user/company/${companyId}?${queryString}`, {}, 'GET')

  const body = await resp.json()

  return body
}

const updateUserByUnitsXPerfil = async (
  id: string,
  updateData: {
    company: string
    rol: {
      id: string
      unidades: {id: string; name: string}[]
    }[]
  }[]
) => {
  const resp = await fetchConToken('user/units/role', {id, data: updateData}, 'PUT')

  return await resp.json()
}

const updateUserByUnitsXPerfilMany = async (
  users: {
    userUpdatedId: string
    data: {
      company: string
      rol: {
        id: string
        unidades: {id: string; name: string}[]
      }[]
    }[]
  }[]
) => {
  const resp = await fetchConToken('user/units/role/many', {users}, 'PUT')

  return await resp.json()
}

const getUnitsByRole = async () => {
  const resp = await fetchConToken('user/units-by-role', {}, 'GET')
  const body = await resp.json()

  return body
}

export {
  acceptTerminosCondicionesUser,
  activarUser,
  createUser,
  deleteUser,
  getAdminUsers,
  getAllUsersAsignacionSinPag,
  getAllUsersByCompanyPagination,
  getAllUsersColabsPag,
  getAllUsersPag,
  getAllUsersSinPag,
  getInvitadosUsers,
  getResponsablesUsers,
  getRoles,
  getRolsByCompany,
  getTerminosUserId,
  getUnitsByRole,
  getUserById,
  getUserByIdDashboard,
  updateUser,
  updateUserByUnitsXPerfil,
  updateUserByUnitsXPerfilMany,
  updateUserData,
  updateUserEnterpricesAndRols,
}
